module.exports = __webpack_public_path__ + "img/photo15.d9d1d173.jpg";